const Mines = require('./Production/Mines');
const Farms = require('./Production/Farms');
const Labs = require('./Urban/Labs');
const Temples = require('./Urban/Temples');
const Theaters = require('./Urban/Theaters');
const Arenas = require('./Urban/Arena');
const Libraries = require('./Urban/Libraries');
const Infantry = require('./Military/Infantry');
const Cavalry = require('./Military/Cavalry');
const Artillery = require('./Military/Artillery');
const AirForces = require('./Military/AirForces');
const Governments = require('./Government/Governments');
const Civil = require('./Special/Civil');
const Colonization = require('./Special/Colonization');
const Construction = require('./Special/Construction');
const Military = require('./Special/Military');

module.exports = {
    ...Mines,
    ...Farms,
    ...Labs,
    ...Temples,
    ...Theaters,
    ...Arenas,
    ...Libraries,
    ...Infantry,
    ...Cavalry,
    ...Artillery,
    ...AirForces,
    ...Governments,
    ...Civil,
    ...Colonization,
    ...Construction,
    ...Military,
}